var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadReceiptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5835 13.6663C1.25016 13.6663 0.958496 13.5413 0.708496 13.2913C0.458496 13.0413 0.333496 12.7497 0.333496 12.4163V9.43717H1.5835V12.4163H12.4168V9.43717H13.6668V12.4163C13.6668 12.7497 13.5418 13.0413 13.2918 13.2913C13.0418 13.5413 12.7502 13.6663 12.4168 13.6663H1.5835ZM7.00016 10.4788L2.97933 6.45801L3.87516 5.56217L6.37516 8.06217V0.333008H7.62516V8.06217L10.1252 5.56217L11.021 6.45801L7.00016 10.4788Z",
    fill: "#182C55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReceiptIcon);
export default __webpack_public_path__ + "static/media/downloadReceiptIcon.4ef137b0.svg";
export { ForwardRef as ReactComponent };